@for (section of sections; track section.name) {
	<mat-expansion-panel class="section-panel">
		<mat-expansion-panel-header>
			<mat-panel-title>
				<h5 class="bold">{{ section.name }}</h5>
			</mat-panel-title>
		</mat-expansion-panel-header>
		@for (module of section.modules; track module.name) {
			<mat-expansion-panel class="module-panel" [(expanded)]="module.expanded">
				<mat-expansion-panel-header>
					<mat-panel-title>{{ module.name }}</mat-panel-title>
					<span class="expand-links">
						<button
							type="button"
							class="expand-link"
							(click)="setAllExpanded(section, true); $event.stopPropagation()"
							(keydown)="$event.stopPropagation()"
						>
							expand all
						</button>
						<button
							type="button"
							class="expand-link"
							(click)="setAllExpanded(section, false); $event.stopPropagation()"
							(keydown)="$event.stopPropagation()"
						>
							collapse all
						</button>
					</span>
				</mat-expansion-panel-header>
				<sb-role-site-claim-permissions [claims]="module.claims" [readOnly]="readOnly" (changed)="changed.emit()" />
			</mat-expansion-panel>
		}
	</mat-expansion-panel>
}
